import { IFormField, JsonItem, TextInputField, TextInputOptions } from "../../../../../shared/components/web-form/web-form.objects"
import _ from "lodash";
import { TextInputType } from "../../../../../shared/components/web-form/form-field/text-input";

export class RevisionCommentOptions {
    linkedInputId: string;
    showForValues: string[];
    constructor(linkedInputId: string, showForValues: string[]) {
        this.linkedInputId = linkedInputId;
        this.showForValues = showForValues;
    }
}

export class RevisionCommentInput implements IFormField {
    fieldId: string; 
    displayName: string;
    description: string;
    isRequired: boolean;
    propertyName: string; 
    defaultVal: any; 
    initialVal: any;
    commentOptions: RevisionCommentOptions;
    options: TextInputOptions;

    textInputField: TextInputField;

    constructor(propertyName: string, fieldId: string, displayName: string, description: string, isRequired: boolean, options: RevisionCommentOptions) {
        this.fieldId = fieldId;
        this.displayName = displayName;
        this.description = description;
        this.isRequired = isRequired;
        this.propertyName = propertyName;
        this.commentOptions = options;
        this.options = new TextInputOptions(TextInputType.Any, -99, -99, false, 5);

        this.defaultVal = "";
        this.initialVal = "";

        this.textInputField = new TextInputField(this.propertyName, this.fieldId, this.displayName, this.description, true, this.options);
    }

    generateHtml(): string {
        let input = this.textInputField.generateHtml();
        let html = `
            <div id="${this.fieldId}-container" class="d-none">
                ${input}
            </div>
        `
        return html;
    }

    initialize() {
        this.textInputField.initialize();

        $(`#${this.commentOptions.linkedInputId}`).on("changed.bs.select", () => {
            let val = <string>$(`#${this.commentOptions.linkedInputId}`).val();
            if (this.commentOptions.showForValues.includes(val)) {
                $(`#${this.fieldId}-container`).removeClass("d-none");
            }
            else {
                this.textInputField.prepopulate([]);
                $(`#${this.fieldId}-container`).addClass("d-none");
            }
        })
    }

    setOptions(pickLists: JsonItem[]) {
        this.textInputField.setOptions(pickLists);
    }

    prepopulate(items: any[]): void {
        this.textInputField.prepopulate(items);
    }

    updateItem(item: any): any {
        let updatedItem = this.textInputField.updateItem(item);
        return updatedItem;
    }

    getValue(): any {
        let val = this.textInputField.getValue();
        return val;
    }

    setValue(formData: any) {
        this.textInputField.setValue(formData);
    }

    checkValid(): boolean {
        let val = <string>$(`#${this.commentOptions.linkedInputId}`).val();
        if (this.commentOptions.showForValues.includes(val)) {
            return this.textInputField.checkValid();
        }
        else {
            return true;
        }
    }

    checkChanged(): boolean {
        let val = this.textInputField.checkChanged();
        return val;
    }

    displayValid(isValid: boolean) {
        this.textInputField.displayValid(isValid);
    }

    resetValidDisplay() {
        this.textInputField.resetValidDisplay();
    }

    compareItems(item1: any, item2: any): boolean {
        let result = this.textInputField.compareItems(item1, item2);
        return result;
    }

    generateChangeHtml(newItem: any, prevItem: any): string {
        let html = this.textInputField.generateChangeHtml(newItem, prevItem);

        return html;
    }
}

